var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { setIndentUsage, setNewPreferences, setRoundingUsage, setSubstrateUsage, } from '../../../../../Redux/slices/Preferences/preferences';
import ColorPickerControl from '../ColorsControlSection/ColorPicker';
import { useSelector } from 'react-redux';
import { selectMatrixPreferences } from '../../../../../Redux/selectors/selectors';
import { Switch, Typography } from 'antd';
import styles from '../../../Preferences.module.scss';
import { useTypeDispatch } from '../../../../../hooks/useTypeHooks';
var CellSettings = function (_a) {
    var currentTheme = _a.currentTheme;
    var dispatch = useTypeDispatch();
    var _b = useSelector(selectMatrixPreferences), useSubstrate = _b.useSubstrate, rounding = _b.rounding, indent = _b.indent;
    var Switches = [
        {
            name: 'use_rounding',
            value: rounding,
            handleOnChange: function (value) { return dispatch(setRoundingUsage(value)); },
            text: 'Apply rounding cell',
        },
        {
            name: 'use_indent',
            value: indent,
            handleOnChange: function (value) { return dispatch(setIndentUsage(value)); },
            text: 'Apply indent cell',
        },
        // {
        // 	name: 'use_advanced_settings',
        // 	value: isShowAdvancedSettings,
        // 	handleOnChange: (value) => setIsShowAdvancedSettings(value),
        // 	text: 'Activate advanced settings',
        // },
    ];
    return (_jsxs(_Fragment, { children: [_jsx(ColorPickerControl, { color: currentTheme.matrix.substrate['border color'], pickerLabel: 'Selected cell', onColorPicked: function (hex) {
                    dispatch(setNewPreferences('border color', hex, 'matrix', 'substrate'));
                }, position: 'top' }), _jsxs("div", __assign({ className: styles.switchWrapper }, { children: [_jsx(Switch, { checked: useSubstrate, onChange: function (value) { return dispatch(setSubstrateUsage(value)); }, size: 'small', className: useSubstrate ? styles.switchButtonChecked : styles.switchButtonNotChecked }), _jsx(Typography, { children: "Apply substrate" })] })), useSubstrate ? (_jsx(_Fragment, { children: _jsx(ColorPickerControl, { color: currentTheme.matrix.substrate.color, pickerLabel: 'Substrate', onColorPicked: function (hex) {
                        dispatch(setNewPreferences('color', hex, 'matrix', 'substrate'));
                    }, position: 'top' }) })) : null, Switches.map(function (item) { return (_jsxs("div", __assign({ className: styles.switchWrapper }, { children: [_jsx(Switch, { checked: item.value, onChange: item.handleOnChange, size: 'small', className: item.value ? styles.switchButtonChecked : styles.switchButtonNotChecked }), _jsx(Typography, { children: item.text })] }), item.name)); })] }));
};
export default CellSettings;
